import type { TFunction } from 'i18next'

// Each end is a number of days before today; the label is date_range.<key>.
export const DATE_PRESETS = [
  { key: 'today', fromDaysAgo: 0, toDaysAgo: 0 },
  { key: 'yesterday', fromDaysAgo: 1, toDaysAgo: 1 },
  { key: 'last_7_days', fromDaysAgo: 6, toDaysAgo: 0 },
  { key: 'last_30_days', fromDaysAgo: 29, toDaysAgo: 0 }
] as const

const daysAgo = (today: Date, days: number) => {
  const date = new Date(today)
  date.setDate(date.getDate() - days)
  return date
}

// The shape Base.DatePicker takes as presets, resolved against today.
export function datePresets(t: TFunction, today = new Date()) {
  return DATE_PRESETS.map(({ key, fromDaysAgo, toDaysAgo }) => ({
    label: t(`date_range.${key}`),
    from: daysAgo(today, fromDaysAgo),
    to: daysAgo(today, toDaysAgo)
  }))
}
